import {
  Grid,
  Typography,
  makeStyles,
  Popover,
  IconButton,
} from "@material-ui/core";
import filter from "../../../assets/filter.svg";
import w_filter from "../../../assets/white_filter.svg";
import { useSelector } from "react-redux";
import Dropdown from "../../../constants/CustomDropdown";
import { useState } from "react";
import { Close } from "@material-ui/icons";

export default function Filters(props) {
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const filters = useSelector((state) => state.filters.value);
  const countries_values = props.countries;
  const continents_values = props.continents;
  const tabValue = props.tabValue;
  const t = props.t;

  const order_by_values_stock = [
    "Best Match",
    t("market_cap"),
    t("theme_related"),
    t("fair_price"),
    t("potential"),
    t("past_history"),
    t("solvency"),
    t("earnings"),
  ];

  const order_by_values_etf = ["Best Match", t("market_cap")];

  const [country, setCountry] = useState(
    filters?.Country ? filters.Country : "ALL"
  );
  const [continent, setContinent] = useState(
    filters?.Continent ? filters.Continent : "ALL"
  );

  const [isopen, setIsOpen] = useState(false);

  return (
    <>
      <Grid
        container
        style={{
          padding: isDesktopOrLaptop
            ? "25px 0px 45px 341px"
            : "15px 15px 15px 11px",
        }}
      >
        <Grid
          item
          style={{
            display: "flex",
            alignItems: "center",
            width: isDesktopOrLaptop ? "757px" : "100%",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 4 : 6}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontSize: "16px",
                color: "#808080",
              }}
            >
              {t("filter")}
            </Typography>
            <div
              style={{
                width: isDesktopOrLaptop ? "37px" : "33px",
                height: isDesktopOrLaptop ? "37px" : "33px",
                borderRadius: "50%",
                border: "solid 1.5px #808080",
                backgroundColor:
                  (filters?.Country && filters?.Country !== "ALL") ||
                  (filters?.Continent && filters?.Continent !== "ALL")
                    ? "#0040ff"
                    : null,
                marginLeft: "15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={(e) => {
                setIsOpen(e.currentTarget);
              }}
            >
              <img
                src={
                  (filters?.Country && filters?.Country !== "ALL") ||
                  (filters?.Continent && filters?.Continent !== "ALL")
                    ? w_filter
                    : filter
                }
                alt="filter"
              ></img>
            </div>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 8 : 6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {isDesktopOrLaptop ? (
              <Typography
                style={{
                  fontFamily: "Overpass",
                  fontSize: "16px",
                  color: "#808080",
                  paddingRight: "15px",
                }}
              >
                {t("order")}
              </Typography>
            ) : null}
            <Dropdown
              values={
                tabValue === 2 ? order_by_values_etf : order_by_values_stock
              }
              value={"Best Match"}
            />
          </Grid>
        </Grid>
      </Grid>
      <Popover
        open={Boolean(isopen)}
        anchorEl={isopen}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          style: {
            borderRadius: "15px",
            border: "solid 1.5px #808080",
            width: isDesktopOrLaptop ? "325px" : "300px",
            height: "155px",
          },
        }}
        onClose={() => {
          setIsOpen(!isopen);
        }}
      >
        <Grid
          container
          style={{
            alignItems: "center",
            height: "100%",
            width: "100%",
            padding: "20px",
            paddingTop: "10px",
          }}
        >
          <Grid item xs={12} style={{ padding: 0 }}>
            <IconButton
              onClick={() => {
                setIsOpen(!isopen);
              }}
              style={{
                padding: 0,
              }}
            >
              <Close style={{ fontSize: "15px" }} />
            </IconButton>
          </Grid>
          <Grid item xs={3}>
            <Typography
              variant="body2"
              style={{
                fontSize: "14px",
                fontWeight: 800,
                color: "#808080",
                fontFamily: "Overpass",
              }}
            >
              {t("country")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={9}
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Dropdown
              type="Country"
              value={country}
              values={countries_values}
              setIsOpen={setIsOpen}
            />
          </Grid>

          <Grid item xs={3} style={{ paddingTop: "10px" }}>
            <Typography
              variant="body2"
              style={{
                fontSize: "14px",
                fontWeight: 800,
                color: "#808080",
                fontFamily: "Overpass",
              }}
            >
              {t("continent")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={9}
            style={{
              paddingTop: "10px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Dropdown
              type="Continent"
              value={continent}
              values={continents_values}
              setIsOpen={setIsOpen}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
}
